import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

const LinkedElement = ({ children, className, disabled = false, href = null }) => {
  const onClick = useCallback(
    (e) => {
      if (disabled) {
        e.preventDefault();
      }
    },
    [disabled],
  );

  if (!href) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  return (
    <Link className={className} onClick={onClick} to={href}>
      {children}
    </Link>
  );
};

LinkedElement.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
};

export default LinkedElement;
